var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUni(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.833 1.70345C25.833 1.48244 25.9208 1.27048 26.077 1.1142C26.2333 0.957916 26.4453 0.870117 26.6663 0.870117H38.3213C38.5423 0.870117 38.7543 0.957916 38.9107 1.1142C39.0668 1.27048 39.1547 1.48244 39.1547 1.70345V38.3334C39.1547 38.5544 39.0668 38.7664 38.9107 38.9228C38.7543 39.0789 38.5423 39.1668 38.3213 39.1668H25.833V1.70345Z",
    fill: "#66E1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1463 11.5834V1.70345C39.1463 1.48244 39.0585 1.27048 38.9023 1.1142C38.746 0.957916 38.534 0.870117 38.313 0.870117H26.6663C26.4453 0.870117 26.2333 0.957916 26.077 1.1142C25.9208 1.27048 25.833 1.48244 25.833 1.70345V24.9034L39.1463 11.5834Z",
    fill: "#C2F3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8288 20.8516H12.5088V39.1666H25.8288V20.8516Z",
    fill: "#E3E3E3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8271 21.4799V20.8516H12.5088V34.7999L25.8271 21.4799Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.833 1.70345C25.833 1.48244 25.9208 1.27048 26.077 1.1142C26.2333 0.957916 26.4453 0.870117 26.6663 0.870117H38.3213C38.5423 0.870117 38.7543 0.957916 38.9107 1.1142C39.0668 1.27048 39.1547 1.48244 39.1547 1.70345V38.3334C39.1547 38.5544 39.0668 38.7664 38.9107 38.9228C38.7543 39.0789 38.5423 39.1668 38.3213 39.1668H25.833V1.70345Z",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8271 39.1666H12.5088V20.8516H25.8271",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7571 14.7801C19.6008 14.6239 19.389 14.5361 19.168 14.5361C18.947 14.5361 18.7351 14.6239 18.5788 14.7801L12.5088 20.8518H25.8338L19.7571 14.7801Z",
    fill: "#FF808C",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5083 39.1663H3.34993C3.12892 39.1663 2.91697 39.0785 2.76068 38.9223C2.6044 38.766 2.5166 38.554 2.5166 38.333V30.833H12.5083V39.1663Z",
    fill: "#FFDDA1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 30.833H2.5V34.1663H12.5V30.833Z",
    fill: "#FFBC44"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5083 39.1663H3.34993C3.12892 39.1663 2.91697 39.0785 2.76068 38.9223C2.6044 38.766 2.5166 38.554 2.5166 38.333V30.833H12.5083V39.1663Z",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5081 25.8467H4.6281C4.49101 25.8465 4.35601 25.8803 4.23508 25.9448C4.11413 26.0093 4.01098 26.1027 3.93476 26.2167L1.71476 29.55C1.63126 29.6755 1.58335 29.8213 1.57615 29.9718C1.56895 30.1223 1.60272 30.2722 1.67386 30.405C1.74501 30.5378 1.85088 30.649 1.98016 30.7265C2.10946 30.804 2.25736 30.8448 2.4081 30.845H12.5081V25.8467Z",
    fill: "#FF808C",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1562 4.20215V5.86715",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4863 4.20215V5.86715",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8164 4.20215V5.86715",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1562 10.8613V12.5263",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4863 10.8613V12.5263",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8164 10.8613V12.5263",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1562 17.5215V19.1865",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4863 17.5215V19.1865",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8164 17.5215V19.1865",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1562 24.1816V25.8466",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4863 24.1816V25.8466",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8164 24.1816V25.8466",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9414 26.6416V28.3066",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2715 26.6416V28.3066",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6016 26.6416V28.3066",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9414 33.3018V34.9668",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2715 33.3018V34.9668",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6016 33.3018V34.9668",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1562 30.8418V32.5068",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4863 30.8418V32.5068",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8164 30.8418V32.5068",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2785 10.8614C15.1571 10.7523 15.9667 10.3298 16.5586 9.67141C17.1505 9.01308 17.4848 8.16321 17.5002 7.27805C17.5 6.7972 17.403 6.32131 17.2148 5.87883C17.0265 5.43636 16.751 5.03638 16.4047 4.70281C16.0584 4.36923 15.6483 4.10893 15.1991 3.93743C14.7499 3.76593 14.2707 3.6868 13.7902 3.70471C13.3862 2.84596 12.7462 2.11993 11.9449 1.61141C11.1436 1.1029 10.2142 0.832932 9.26518 0.833047C7.9702 0.828015 6.72055 1.30947 5.7637 2.18206C4.80683 3.05465 4.21255 4.25476 4.09852 5.54471C3.70688 5.46151 3.30161 5.46688 2.91231 5.56045C2.52303 5.65401 2.15958 5.83341 1.84853 6.0855C1.53749 6.3376 1.28672 6.65601 1.11457 7.0175C0.942411 7.37896 0.853221 7.77435 0.853516 8.17471C0.857725 8.54156 0.936056 8.90376 1.0838 9.23958C1.23155 9.57538 1.44566 9.87784 1.71328 10.1288C1.98088 10.3798 2.29648 10.574 2.64106 10.6999C2.98566 10.8258 3.35215 10.8807 3.71851 10.8614H14.2785Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2785 7.52844H3.71853C3.28663 7.52684 2.85941 7.43904 2.46188 7.27019C2.06436 7.10134 1.70454 6.85482 1.40353 6.5451C1.04516 7.01275 0.851759 7.58594 0.853528 8.1751C0.857501 8.54202 0.935674 8.90434 1.08334 9.24025C1.23101 9.57617 1.44512 9.87874 1.71278 10.1297C1.98044 10.3807 2.29613 10.575 2.64083 10.7008C2.98553 10.8266 3.35211 10.8814 3.71853 10.8618H14.2785C15.1571 10.7527 15.9667 10.3302 16.5586 9.6718C17.1505 9.01347 17.4849 8.1636 17.5002 7.27844C17.5002 6.7114 17.3647 6.15259 17.1052 5.64844C16.7985 6.14797 16.3868 6.57484 15.8987 6.89945C15.4106 7.22409 14.8578 7.4387 14.2785 7.52844Z",
    fill: "#E3E3E3"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2785 10.8614C15.1571 10.7523 15.9667 10.3298 16.5586 9.67141C17.1505 9.01308 17.4848 8.16321 17.5002 7.27805C17.5 6.7972 17.403 6.32131 17.2148 5.87883C17.0265 5.43636 16.751 5.03638 16.4047 4.70281C16.0584 4.36923 15.6483 4.10893 15.1991 3.93743C14.7499 3.76593 14.2707 3.6868 13.7902 3.70471C13.3862 2.84596 12.7462 2.11993 11.9449 1.61141C11.1436 1.1029 10.2142 0.832932 9.26518 0.833047C7.9702 0.828015 6.72055 1.30947 5.7637 2.18206C4.80683 3.05465 4.21255 4.25476 4.09852 5.54471C3.70688 5.46151 3.30161 5.46688 2.91231 5.56045C2.52303 5.65401 2.15958 5.83341 1.84853 6.0855C1.53749 6.3376 1.28672 6.65601 1.11457 7.0175C0.942411 7.37896 0.853221 7.77435 0.853516 8.17471C0.857725 8.54156 0.936056 8.90376 1.0838 9.23958C1.23155 9.57538 1.44566 9.87785 1.71328 10.1288C1.98088 10.3798 2.29648 10.574 2.64106 10.6999C2.98566 10.8258 3.35215 10.8807 3.71851 10.8614H14.2785Z",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUni);
export default __webpack_public_path__ + "static/media/uni.f7bcdd010b49ca99a9d25a3eefefd1bc.svg";
export { ForwardRef as ReactComponent };